import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom/client'

import './styles/app.scss'
import reportWebVitals from './reportWebVitals'

import PageLoader from './components/PageLoader/PageLoader'

const root = ReactDOM.createRoot(document.getElementById('root'))

const AppLazy = lazy(() => import('./App'))

root.render(
  <React.StrictMode>
    <Suspense fallback={<PageLoader />}>
      <AppLazy />
    </Suspense>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
